// extracted by mini-css-extract-plugin
export default {"div":"profile_div__X6XOC","pic":"profile_pic__fbRoW"};